import { render, staticRenderFns } from "./KCatalogItem.vue?vue&type=template&id=06b88086&"
import script from "./KCatalogItem.vue?vue&type=script&lang=js&"
export * from "./KCatalogItem.vue?vue&type=script&lang=js&"
import style0 from "./KCatalogItem.vue?vue&type=style&index=0&id=06b88086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports